import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AlertModal from '../AlertModal';
import useGlobalModal from '../GlobalModal/useGlobalModal';
import {
  errorNotificationActions,
  selectErrorNotificationError,
  selectErrorNotificationIsOpen,
} from './errorNotificationSlice';

function ErrorNotification() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectErrorNotificationIsOpen);
  const error = useAppSelector(selectErrorNotificationError);
  const { showGlobalModal } = useGlobalModal();

  function handleClose() {
    dispatch(errorNotificationActions.hideError);
  }

  useEffect(() => {
    if (isOpen && error) {
      showGlobalModal(() => <AlertModal title={t('App.warning')} message={error.message} onClose={handleClose} />);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, error]);

  return <></>;
}

export default ErrorNotification;
